define('GameDayCore/GDModel/load/flow/HeartbeatFlow',['es6ish-class/es6ish-class','jquery','jquery-when-always/jquery-when-always'],function(){
    var classify = require( "es6ish-class/es6ish-class" ),
        Deferred = jquery  = require( "jquery" ).Deferred,
        whenAlways = require("jquery-when-always/jquery-when-always").whenAlways;

    function HeartbeatFlow(worker, operation, dataSource){
        var that = this;
        this.worker = worker;
        this.dataSource = dataSource;
        this.items = [];
        this.runIndex = 0;
        this.addItem(operation, dataSource);

        this.runItemCallback = function(){
            return that.runItem();
        }
        this.nextItemCallback = function(){
            return that.nextItem();
        }
        this.completeCallback = function(){
            return that.complete();
        }
        this.dispatchUpdateCallback = function(){
            return that.dispatchUpdate();
        }
    }        

    
    HeartbeatFlow.prototype = {
        createItem : function(operation, dataSource){
            return {    
                dataSource : dataSource,
                operation  : operation,
                defer      : null
            }
        },

        addItem : function(operation,dataSource){
            this.items.push(this.createItem(operation, dataSource));
        },

        run : function(){

            var item,
                queue,
                that    = this,
                items   = this.items,
                i       = 0,
                count   = items.length,
                queueItems   = [];

            if(count >= 1){
                for(; i < count; i++){
                    item=items[i];
                    item.defer = Deferred();
                    queueItems.push(item.defer);
                }
                if(count > 1){
                    queue = Deferred();
                    whenAlways.apply(whenAlways,queueItems).always(queue.resolve);
                } else{
                    queue = items[0].defer
                }
            } else {
                queue = Deferred().resolve();
            }

            this.queue = queue;
            this.runIndex = 0;
            this.runItem();

            return this.queue.promise();
        },
        runItem  : function(){
            // console.count('heartbeatFlow run item')
            var item = this.items[this.runIndex],
                that = this;
            this.runIndex++;
            // console.warn("BLERP DERP",item);
            if(item && this.queue){
                this.currentItem=item;
                if(item.dataSource){
                    item.defer.always(function(){
                        // console.warn("FLERGIN BLERP DERP DONE",arguments);
                        item.operation.apply(that,arguments);
                    });
                    this.worker.fetch(item.dataSource)
                        .always(item.defer.resolve);
                }else{
                    item.operation.call(that);
                }
                item.defer.always(this.runItemCallback);
            }else {
                this.currentItem = null;
                this.complete();
            }
            return;
        },
        nextItem : function(){
            if(this.currentItem){
                this.currentItem.defer.resolve();
            }       
        },
        dispatchUpdate : function(){
            this.worker.dispatchUpdateEvent();
        },
        complete : function(){
            if(this.queue){
                // console.warn("heartbeat flow complete",this)
                this.queue.resolve();
            }
        }

    };

    classify(HeartbeatFlow);

    return HeartbeatFlow;
});
